import { createFeature, createReducer, on } from '@ngrx/store';
import * as luxon from 'luxon';
import * as actions from './rfr-cpl-search.actions';
import { RfrCplItemI } from 'src/app/api/rfr-cpl-search/rfr-cpl-item.int';

export interface State {
  error: string;
  loaded: boolean;
  loading: boolean;
  data: RfrCplItemI[];
  receivedTime: string;
}

export const initialState: State = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
  receivedTime: null,
};

export default createFeature({
  name: 'rfrCplSearch',
  reducer: createReducer(
    initialState,
    on(actions.load, (state) => ({ ...state, loaded: false, loading: true })),
    on(actions.received, (state, { data }) => ({
      ...state,
      data,
      error: null,
      loaded: true,
      loading: false,
      receivedTime: luxon.DateTime.now().toISO(),
    })),
    on(actions.reset, (state) => ({ ...state, data: [], error: null, loaded: false, loading: false })),
    on(actions.error, (state, { messageText }) => ({ ...state, error: messageText, loaded: false, loading: false })),
  ),
});
